const LinkListMarketplace = [
  {
    icon: 'fas fa-tachometer-alt',
    name: 'Dashboard',
    url: '/dashboard',
  },
  {
    icon: 'far fa-calendar',
    name: 'Calendar',
    url: '/calendar',
    key: ['appointment'],
  },
  {
    icon: 'fas fa-receipt',
    name: 'Sales',
    url: '/sales',
    key: ['appointment', 'invoice'],
    subLinks: [
      {
        icon: 'fas fa-calendar-check',
        name: 'Sales Appointment',
        url: '/sales/appointments',
        key: ['appointment'],
      },
      {
        icon: 'fas fa-receipt',
        name: 'Sales Transactions',
        url: '/sales/transactions',
        key: ['invoice'],
      },
    ],
  },
  {
    icon: 'fas fa-percent',
    name: 'Promotions',
    url: '/promotions',
    key: ['deal', 'lmo', 'discount'],
    subLinks: [
      {
        icon: 'fas fa-briefcase',
        name: 'Deals',
        key: ['deal'],
        url: '/promotions/deals',
      },
      {
        icon: 'fas fa-hourglass-half',
        name: 'Last Minute Openings',
        key: ['lmo'],
        url: '/promotions/lmos',
      },
      // {
      //     icon: 'fas fa-gift',
      //     name: 'Gift Cards',
      //     url: '/promotions/gift-cards',
      // },
      {
        icon: 'fas fa-percentage',
        name: 'Discount Codes',
        key: ['discount'],
        url: '/promotions/discount-codes',
      },
    ],
  },
  {
    icon: 'fa fa-users',
    name: 'Clients',
    key: ['client'],
    url: '/clients',
  },
  {
    icon: 'fa fa-user',
    name: 'Staff Member',
    url: '/staff',
    key: ['staff', 'commission', 'staffcloseddate'],
    subLinks: [
      {
        icon: 'fas fa-user-friends',
        name: 'Staff Members',
        key: ['staff'],
        url: '/staff/members',
      },
      {
        icon: 'fas fa-clock',
        name: 'Staff Availability',
        key: ['staff'],
        url: '/staff/hours',
      },
      {
        icon: 'fas fa-comment-dollar',
        name: 'Commissions',
        key: ['commission'],
        url: '/staff/commissions',
      },
      {
        icon: 'fas fa-calendar-day',
        name: 'Dates Closed',
        key: ['staffcloseddate'],
        url: '/staff/closed-dates',
      },
    ],
  },
  {
    icon: 'fas fa-clipboard-list',
    name: 'Services',
    key: ['service'],
    url: '/services',
  },
  {
    icon: 'fas fa-chart-pie',
    name: 'Analytics',
    key: [
      'business.appointments_statistics.view',
      'business.clients_statistics.view',
      'business.sales_statistics.view',
    ],
    url: '/analytics',
  },
  {
    icon: 'fas fa-comments',
    name: 'Client Messages',
    key: ['messages'],
    url: '/messages',
  },
  {
    icon: 'fas fa-images',
    name: 'Bookable Photo',
    key: ['bookablephoto'],
    url: '/bookable_photos',
  },
  {
    claimed: {
      icon: 'fas fa-list-ul',
      name: 'Three Timeslot',
      url: '/requests/three-time-requests/',
    },
    icon: 'fas fa-list-ul',
    name: 'Requests',
    url: '/requests',
    subLinks: [
      {
        icon: 'fas fa-list-ul',
        name: 'Three Timeslot',
        url: '/requests/three-time-requests/',
        key: ['appointmentsuggestedtime'],
      },
      {
        icon: 'fas fa-list-ul',
        name: 'Services',
        url: '/requests/services/',
      },
    ],
  },
  {
    icon: 'fas fa-cog',
    name: 'Settings',
    url: '/settings',
    subLinks: [
      {
        icon: 'fas fa-briefcase',
        name: 'Business Profile',
        key: ['business'],
        url: '/settings/business-profile',
      },
      {
        icon: 'fas fa-briefcase',
        name: 'Business Close Date',
        key: ['businesscloseddate'],
        url: '/settings/closed-dates',
      },
      {
        icon: 'fas fa-shield-alt',
        name: 'Access Level',
        url: '/settings/permissions',
        // isDev: true,
      },
      {
        icon: 'fas fa-money-check-alt',
        name: 'Payment',
        url: '/settings/payment',
      },
      // {
      //     icon: 'fas fa-mail-bulk',
      //     // name: 'Communications Preferences',
      //     name: 'Communications',
      //     url: '/settings/communications',
      // },
      {
        icon: 'fas fa-bullhorn',
        name: 'Marketplace',
        key: ['business.marketplace_switch'],
        url: '/settings/marketplace',
      },
      {
        icon: 'fas fa-map-marked-alt',
        name: 'Location',
        url: '/settings/locations',
      },
    ].filter((i) => i),
  },
].filter((i) => i);

export default LinkListMarketplace;
